import { render, staticRenderFns } from "./page.vue?vue&type=template&id=30ac9884&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=30ac9884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ac9884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30ac9884')) {
      api.createRecord('30ac9884', component.options)
    } else {
      api.reload('30ac9884', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=30ac9884&scoped=true&", function () {
      api.rerender('30ac9884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/feature/page.vue"
export default component.exports